import {NotificationType} from '../enums/enums';
import { Localization } from "../enums/localization";
import {StringHelper} from '../../../helpers/stringHelper';
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Injectable()
export class AppMessage {

  public redirectUrl: string;
  public type: NotificationType;
  public count: number;
  public translateService: TranslateService;

  public getMessage(): string {
    switch (this.type) {
      case NotificationType.NEWISSUENOTIFICATIONS:
        return this.count === 1 ? this.translateService.instant(Localization.NewIssueNotification) :
          StringHelper.format(this.translateService.instant(Localization.NewIssueNotifications), [this.count.toString()]);
      case NotificationType.UNREADISSUENOTIFICATIONMESSAGES:
        return this.count === 1 ? this.translateService.instant(Localization.UnreadIssueNotificationMessage) :
          StringHelper.format(this.translateService.instant(Localization.UnreadIssueNotificationMessages), [this.count.toString()]);
    }
  }

  public getRedirectUrl(): string {
    return this.redirectUrl;
  }
}
